import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  baseURL: "https://wow.pesa.solutions/api/",
  //baseURL: "http://localhost:12340/api/",
});

const writeAxiosInstance = axios.create({
  baseURL: "https://wow.pesa.solutions/api/",
  //baseURL: "http://localhost:12340/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;
